<template>
  <div class="top-bar-item" @mouseenter="mouseMoveHandler" @mouseleave="mouseOutHandler">
    <slot></slot>
    <template v-if="show">
      <UserInfo @change="changePasswordPop" @reset="resetUserGoogleAuthenticator"></UserInfo>
    </template>
    <!-- 修改密码 -->
    <Drawer title="修改密码" :visible.sync="changePasswordPopShow" @handClick="changePassword">
      <div>
        <el-form ref="form" :model="changeInfo" label-width="130px" label-position="left">
          <el-form-item size="mini" label="原密码">
            <el-input v-model="changeInfo.oldPassword" type="password"></el-input>
          </el-form-item>
          <el-form-item size="mini" label="新密码">
            <el-input v-model="changeInfo.newPassword" type="password"></el-input>
          </el-form-item>
          <el-form-item size="mini" label="重复新密码">
            <el-input v-model="changeInfo.newPassword2" type="password"></el-input>
          </el-form-item>
          <!--<el-form-item>
            <el-button type="primary" @click="changePassword">确定</el-button>
            <el-button @click="changePasswordPopShow = false">取消</el-button>
          </el-form-item>-->
        </el-form>
      </div>
    </Drawer>
  </div>
</template>

<script>
import UserInfo from "@/components/UserInfo.vue";
import Drawer from "@/components/Drawer.vue";
export default {
  name: "TopBarItem",
  components: {UserInfo, Drawer},
  data () {
    return {
      show: false,
      changePasswordPopShow: false,
      changeInfo: {
        id: 0,
        oldPassword: "",
        newPassword: "",
        newPassword2: ""
      }
    }
  },
  methods: {
      resetUserGoogleAuthenticator() {
          let that = this
          // console.log("resetUserGoogleAuthenticator")
          this.$confirm("重置验证后原有的安全验证将无法使用，点击确定后将退出系统重新登录进行绑定。", "确认要重置验证绑定吗？", {
              confirmButtonText: '确定',
              confirmButtonClass: 'confirm-btn-blue',
              iconClass: 'el-icon-c-yellow',
              cancelButtonText: '取消'
          }).then( () => {
              // console.log("resetGoogleAuthenticator for " + this.$store.state.userInfo.id)
              that.$post(that.$uri.user.resetGoogleAuthenticator, {id: this.$store.state.userInfo.id}).then(res => {
                  // console.log("resetGoogleAuthenticator res " + JSON.stringify(res))
                  if (res.success) {
                      that.$message.success("重置完成")
                  } else {
                      that.$message.error("重置失败")
                  }
              })
          }).catch( () => {})
          // this.$message.success("重置完成")
      },
    mouseMoveHandler() {
      this.show = true
    },
    mouseOutHandler() {
      this.show = false
    },
    changePasswordPop () {
      // console.log("ssssssssssss")
      this.changeInfo.id = this.$store.state.userInfo.id
      this.changePasswordPopShow = true
    },
    changePassword () {
      let info = {...this.changeInfo}
      if (!info.oldPassword || !info.newPassword) {
        this.$message.error("输入不能为空")
        return
      }
      if (info.newPassword !== info.newPassword2) {
        this.$message.error("两次密码不一致")
        return
      }
      info.oldPassword= md5(info.oldPassword)
      info.newPassword= md5(info.newPassword)
      let that = this
      that.$post(that.$uri.login.changePassword, info).then(res => {
        that.$message.success("修改成功")
        setTimeout( () => {
          that.$router.push("/")
        }, 1000)
      })
    }
  }
};
</script>

<style lang="less" scoped>
  .top-bar-item {
    /*width: 100%;*/
    /*height: 100%;*/
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .top-bar-item:hover {
    background: rgba(0, 0, 0, 0.65);
  }
</style>
